module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "loop_28.45019a0d.mp4";